function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { SCROLLING_SPEED } from '../constants';
/**
 * @typedef {import('../../../types/index').Choices.Choice} Choice
 */

var List = /*#__PURE__*/function () {
  /**
   * @param {{ element: HTMLElement }} args
   */
  function List(_ref) {
    var element = _ref.element;

    _classCallCheck(this, List);

    this.element = element;
    this.scrollPos = this.element.scrollTop;
    this.height = this.element.offsetHeight;
  }

  _createClass(List, [{
    key: "clear",
    value: function clear() {
      this.element.innerHTML = '';
    }
    /**
     * @param {Element | DocumentFragment} node
     */

  }, {
    key: "append",
    value: function append(node) {
      this.element.appendChild(node);
    }
    /**
     * @param {string} selector
     * @returns {Element | null}
     */

  }, {
    key: "getChild",
    value: function getChild(selector) {
      return this.element.querySelector(selector);
    }
    /**
     * @returns {boolean}
     */

  }, {
    key: "hasChildren",
    value: function hasChildren() {
      return this.element.hasChildNodes();
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      this.element.scrollTop = 0;
    }
    /**
     * @param {Element} element
     * @param {1 | -1} direction
     */

  }, {
    key: "scrollToChildElement",
    value: function scrollToChildElement(element, direction) {
      var _this = this;

      if (!element) {
        return;
      }

      var listHeight = this.element.offsetHeight; // Scroll position of dropdown

      var listScrollPosition = this.element.scrollTop + listHeight;
      var elementHeight = element.offsetHeight; // Distance from bottom of element to top of parent

      var elementPos = element.offsetTop + elementHeight; // Difference between the element and scroll position

      var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
      requestAnimationFrame(function () {
        _this._animateScroll(destination, direction);
      });
    }
    /**
     * @param {number} scrollPos
     * @param {number} strength
     * @param {number} destination
     */

  }, {
    key: "_scrollDown",
    value: function _scrollDown(scrollPos, strength, destination) {
      var easing = (destination - scrollPos) / strength;
      var distance = easing > 1 ? easing : 1;
      this.element.scrollTop = scrollPos + distance;
    }
    /**
     * @param {number} scrollPos
     * @param {number} strength
     * @param {number} destination
     */

  }, {
    key: "_scrollUp",
    value: function _scrollUp(scrollPos, strength, destination) {
      var easing = (scrollPos - destination) / strength;
      var distance = easing > 1 ? easing : 1;
      this.element.scrollTop = scrollPos - distance;
    }
    /**
     * @param {*} destination
     * @param {*} direction
     */

  }, {
    key: "_animateScroll",
    value: function _animateScroll(destination, direction) {
      var _this2 = this;

      var strength = SCROLLING_SPEED;
      var choiceListScrollTop = this.element.scrollTop;
      var continueAnimation = false;

      if (direction > 0) {
        this._scrollDown(choiceListScrollTop, strength, destination);

        if (choiceListScrollTop < destination) {
          continueAnimation = true;
        }
      } else {
        this._scrollUp(choiceListScrollTop, strength, destination);

        if (choiceListScrollTop > destination) {
          continueAnimation = true;
        }
      }

      if (continueAnimation) {
        requestAnimationFrame(function () {
          _this2._animateScroll(destination, direction);
        });
      }
    }
  }]);

  return List;
}();

export { List as default };